import * as components from './components';

export default [
  {
    path: '/claims/:status?',
    component: components.ClaimList,
    name: 'claimList'
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/claims/routes.js